import request from "@/utils/request";

export default function getFromMessage(fromType,fromId,createdTime) {
    return request({
        url: `/chatLog/getFromMessage/`+fromType+`/`+fromId+`/`+createdTime,
        method: 'get',
    })
}